<template>
  <div class="card-container" ref="cardContainer">
    <div id="customCard-container">
      <div class="fl">
        <label class="input-label">Card number:</label>
        <div class="input-holder" data-cse="encryptedCardNumber"></div>
        <ul id="allowed-cards">
          <li v-for="card in allowedCards" :key="card">
            <img
                :src="`https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/small/${card}.png`"
                class="card-brand-logo"
                :alt="card"
            />
          </li>
        </ul>
      </div>
      <div class="fls">
        <div class="fls gr gr-SH">
          <div class="fl">
            <label class="input-label">Expiry date:</label>
            <div class="input-holder" data-cse="encryptedExpiryDate"></div>
          </div>
          <div class="fl">
            <label class="input-label">CVV/CVC:</label>
            <div class="input-holder" data-cse="encryptedSecurityCode"></div>
          </div>
        </div>
      </div>
    </div>
    <div id="card-holder" class="fl">
      <label class="input-label">Cardholder</label>
      <input type="text" name="card_holder"/>
    </div>
    <div id="threeDS-container"></div>
    <div v-if="formSubmitPressed && (!isAdyenValid || !adyenHasInput)" class="error">
      {{ $t('my_account.user.generic_invalid') }}
    </div>
  </div>
</template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { useStore } from 'vuex'
import { CustomCard } from '@adyen/adyen-web'
import { getAdyen, isAdyenValid as isAdyenValidRef, adyenHasInput as adyenHasInputRef, formSubmitPressed as formSubmitPressedRef } from "@/composables/useAdyen"
import { ref, toRaw, watch, computed, onMounted, nextTick, onBeforeUnmount } from 'vue'
import { useCheckout } from "@/app/Checkout/composables/useCheckout"
import { usePayment, paymentManager } from "@/composables/usePayment"

const store = useStore()
const adyenCheckout = getAdyen()
const cardContainer = ref( null )
const { adyenConfig } = usePayment()
const { activePaymentMethod } = useCheckout()
const isAdyenValid = isAdyenValidRef
const adyenHasInput = adyenHasInputRef
const formSubmitPressed = formSubmitPressedRef
const allowedCards = computed(() => adyenConfig.value?.allowedCardNetworks?.[activePaymentMethod.value] || [])

let cardInstance = null
const handleConfirm = async (response) => {
  // Support both Fetch Response (3DS flow) and plain API response object (Authorised from Checkout onSubmit)
  if (!response) return

  if (response.url?.type === 'threeDS2') {
    const threeDSConfiguration = { challengeWindowSize: "05" }
    adyenCheckout.value?.createFromAction(response.url, threeDSConfiguration).mount("#threeDS-container")
  } else if (response?.result?.resultCode === 'Authorised' && response?.url) {
    window.location.href = response.url
  }
}

watch(allowedCards, async (brands) => {
  if (!brands?.length || !adyenCheckout.value) return

  await nextTick()

  if (!cardContainer.value) return

  // cleanup previous instance
  if (cardInstance && cardInstance.isConfigured) {
    cardInstance.unmount()
    cardInstance = null
  }

  const cardConfig = {
    hasHolderName: true,
    holderNameRequired: true,
    enableStoreDetails: true,
    brands,
    onConfigSuccess: () => {
      cardInstance.isConfigured = true
    },
  }

  cardInstance = new CustomCard(adyenCheckout.value, cardConfig)
  cardInstance.mount(cardContainer.value)
}, { immediate: true })

onMounted(() => {
  paymentManager.register({
    init: () => cardInstance?.submit(),
    confirm: handleConfirm,
  })
})

onBeforeUnmount(() => {
  if (cardInstance) {
    cardInstance.unmount()
    cardInstance = null
  }
})
</script>
